import React from 'react';
import { connect } from 'react-redux';
import TextTranslate, { TextTranslateString } from '../../TextTranslate/TextTranslate';
import ValidationError from '../ValidationError';

const EmergencyContactForm = ({values, errors, onChange, ...props}) => {

    const defaultFields = {
        first_name: '',
        last_name: '',
        relationship: '',
        phone: '',
    };

    const form = {...defaultFields, ...values};

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        onChange(formData);
    };

    return (
        <form>
            <div className="form-row">
                <div className="form-group col-md-6">
                    <label><TextTranslate name="user-first-name" fallback="First Name"/></label>
                    <input
                        onChange={handleChange}
                        value={form.first_name}
                        name="first_name"
                        type="text"
                        className="form-control"
                        placeholder={TextTranslateString('user-first-name', 'First Name', props.currentLanguage, props.translations)}/>

                    <ValidationError errors={errors} name="first_name" />
                </div>
                <div className="form-group col-md-6">
                    <label><TextTranslate name="user-last-name" fallback="Last Name"/></label>
                    <input
                        onChange={handleChange}
                        value={form.last_name}
                        name="last_name"
                        type="text"
                        className="form-control"
                        placeholder={TextTranslateString('user-last-name', 'Last Name', props.currentLanguage, props.translations)}/>

                    <ValidationError errors={errors} name="last_name" />
                </div>
            </div>
            <div className="form-group">
                <label><TextTranslate name="word-relationship" fallback="Relationship" textOnly/></label>
                <input
                    onChange={handleChange}
                    value={form.relationship}
                    name="relationship"
                    type="text"
                    className="form-control"
                    placeholder={TextTranslateString('word-relationship', 'Relationship', props.currentLanguage, props.translations)}/>

                <ValidationError errors={errors} name="relationship" />
            </div>
            <div className="form-group">
                <label className="d-block mb-0"><TextTranslate name="word-phone-number" fallback="Phone number" textOnly/></label>
                <span className="text-caption-1 text-color-gray d-block m-0 mb-2">
                    <TextTranslate name="form-phone-note" fallback="Please include area code."/>
                </span>
                <input
                    onChange={handleChange}
                    value={form.phone}
                    name="phone"
                    type="text"
                    placeholder="(+44)-XXX-XXX-XXX"
                    className="form-control"/>

                <ValidationError errors={errors} name="phone" />
            </div>
        </form>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations
})

export default connect(mapStateToProps)(EmergencyContactForm);